export const MONTH_AND_YEAR_LABEL_REGEX = /[A-Za-z]{3}'[0-9]{2}/g;

export const BRAND_OR_SUBMERCH_REGEX = /^[a-zA-Z0-9 ()'&-_]+$/g;

export const ASIN_REGEX = /[0-9]{9}[0-9X]|[A-Z][A-Z0-9]{9}/;

export const SELECTION_ENTRY_ALREADY_EXISTS_REGEX =
  /Item '.*' of type '.*' already exists in selection entry '(?<existingEntryId>.+)'\./;
